module.exports = __webpack_public_path__ + "static/media/extract-CHI abstracts.ea5af354.txt";